<template lang="pug">
.md-layout
  .md-layout-item
    md-card#data-table
      md-card-header#header.md-card-header-icon.md-card-header-green
        .card-icon
          md-icon list_alt
        h4.title.inlineTitle
          | {{ title }}
        md-button.margin-left.margin-top(@click='generateFile("print")' :disabled='loadingGeneration.print || dialogsGeneration' class='md-sm md-facebook' style='float: right;')
          template(v-if='!loadingGeneration.print')
            md-icon(style='font-size: 24px !important;') print
            md-tooltip(md-direction="bottom")
              | {{$t('table.printOut')}}
          template(v-else)
            v-progress-circular(
              size='24',
              width='2',
              style='transition: 0.1s; height: 33px;'
              color='#fff'
              indeterminate)
        VueJsonToCsv#csv-component(:json-data='csvData' :csv-title="csvName" :labels='formatedCVSLabels' style='opacity: 0; pointer-events: none;')
        md-button.margin-left.margin-top(@click='generateFile("csv")' :disabled='loadingGeneration.csv || dialogsGeneration' class='md-sm md-facebook' style='float: right;')
          template(v-if='!loadingGeneration.csv')
            md-icon(style='font-size: 24px !important;') table_view
            md-tooltip(md-direction="bottom")
              | {{$t('table.generateSpreadsheet')}}
          template(v-else)
            v-progress-circular(
              size='24',
              width='2',
              style='transition: 0.1s; height: 33px;'
              color='#fff'
              indeterminate)
        md-button.margin-top(@click='generateFile("pdf")' :disabled='loadingGeneration.pdf || dialogsGeneration' class='md-sm md-facebook' style='float: right; margin-right: 0px;')
          template(v-if='!loadingGeneration.pdf')
            md-icon(style='font-size: 24px !important;') picture_as_pdf
            md-tooltip(md-direction="bottom")
              | {{$t('table.exportPdf')}}
          template(v-else)
            v-progress-circular(
              size='24',
              width='2',
              style='transition: 0.1s; height: 33px;'
              color='#fff'
              indeterminate)
        md-button.margin-top(@click='generateFile("xlsx")' v-if='isSefMg'
          :disabled='loadingGeneration.xlsx || dialogsGeneration' class='md-sm md-facebook'
          style='float: right; margin-right: 0px;')
          template(v-if='!loadingGeneration.xlsx')
            XLSXIcon.icon-size
            md-tooltip(md-direction="bottom")
              | {{$t('dataTable.exportXLSX')}}
          template(v-else)
            v-progress-circular(
              size='24',
              width='2',
              style='transition: 0.1s; height: 33px;'
              color='#fff'
              indeterminate)
        md-button.margin-top(@click='generateFile("xls")' v-if='isSefMg'
          :disabled='loadingGeneration.xls || dialogsGeneration' class='md-sm md-facebook'
          style='float: right; margin-right: 0px;')
          template(v-if='!loadingGeneration.xls')
            XLSIcon.icon-size
            md-tooltip(md-direction="bottom")
              | {{$t('dataTable.exportXLS')}}
          template(v-else)
            v-progress-circular(
              size='24',
              width='2',
              style='transition: 0.1s; height: 33px;'
              color='#fff'
              indeterminate)
        md-field(style='float: right; margin-right: 0px;width: 15%;margin-top: 20px;margin-right: 10px;')
          v-select(
            hide-details
            filled
            dense
            clearable
            multiple
            prepend-inner-icon='mdi-account-outline'
            v-model='searchOptions'
            :items='searchLabels'
            @change='updateSearchOptions'
            )
        v-text-field(style='float: right; margin-right: 19px; width: 25%;margin-top: 20px; margin-left: 10px;'
          :placeholder="$t('table.enterWordOrPhraseForTheSearch')"
          hide-details
          filled
          dense
          :value='search'
          @input='updateSearch'
        )
        slot(name='title-left')
      md-card-content
        md-progress-bar.md-primary(
          :class='{ invisible: !delayedLoading }'
          md-mode='query'
          style='margin-bottom: 0px;')
        md-table.paginated-table.table-striped.table-hover(
          id='chatList'
          v-model='data',
          :md-sort='currentSort',
          @update:mdSort='$emit("update:currentSort", $event)'
          :md-sort-order='currentSortOrder',
          @update:mdSortOrder='$emit("update:currentSortOrder", $event)'
          :md-sort-fn='customSort',
          :md-selected-value.sync='selected'
          @update:mdSelectedValue='$emit("selected-items", $event)')
          md-table-toolbar(v-if='!customHeader')
            md-field
              label(for='pages') {{ $t("commonPhrases.perPage") }}
              md-select(v-model='pagination.perPage' name='pages')
                md-option(
                  v-for='item in pagination.perPageOptions',
                  :key='item',
                  :label='item',
                  :value='item') {{ item }}
            md-field
              md-input.mb-3(
                type='search'
                clearable
                style='width: 200px;',
                :placeholder='$t("commonWords.search") + "..."',
                :value='search'
                @input='updateSearch')
          template(v-else)
            slot(name='custom-header' :pagination='pagination')
          md-table-toolbar(
            v-if='selectable'
            slot='md-table-alternate-header'
            slot-scope='{ count }'
            style='position: relative;')
            .backgroundRed.md-toolbar
              .md-toolbar-section-start
                | {{ count }}
                | {{ count > 1 ? $t("commonWords.itemsSelected") : $t("commonWords.itemSelected") }}
              .md-toolbar-section-end(v-if='selectable')
                div(v-if='!allowDeleteSelected')
                  slot(name='deleteSelectedMessage')
                md-button.md-simple.md-github(
                  :disabled='isReadOnly || !allowDeleteSelected'
                  @click='$emit("delete-selected", selected)')
                  md-icon delete
                  | {{ $t("commonWords.delete") }}
                md-button.md-simple.md-github(@click='clearSelection') {{ $t("commonWords.cancel") }}
          md-table-row(
            slot='md-table-row'
            slot-scope='props'
            :md-selectable='selectable ? "multiple" : undefined'
            @click='$emit("click-row", props)'
            style='cursor: pointer;',
            :class='rowClasses(props.item)')
            slot(name='cells' v-bind='props')
      md-card-actions(md-alignment='space-between')
        div
          p.card-category
            | {{ $t("commonWords.showingItems", { from: from + 1, to: to, total: total }) }}
        slot(name='footer' :pagination='pagination')
        pagination.pagination-no-border.pagination-success(
          v-model='pagination.currentPage'
          @input='$emit("update:currentPage", pagination.currentPage)',
          :per-page='pagination.perPage',
          :total='total')
  //- esse dialog só é mostrado se tiver um carregamento demorado
  //- (geralmente mais de 1000 itens)
  v-dialog(v-model='dialogsGeneration' persistent max-width="400")
    v-card(style='padding: 8px;')
      v-card-text(style='text-align: center; padding-top: 4px;')
        h3 {{ slowRequestMessage() }}
        v-progress-circular(
          size='200',
          width='4',
          style='transition: 0.1s'
          color='#9c27b0'
          :value='progress',
          :indeterminate='progress >= 90')
          b(v-if='progress !== null' style='font-size: 35px;') {{ progress + "%" }}
      v-card-actions.mt-2.pb-3.px-4
        v-btn.elevation-0(
          :disabled='progress >= 90'
          @click='dialogsGeneration = false',
          text,
          color='#FF0000') {{$t('table.cancel')}}
        v-spacer
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import enumPropValidator from '@/helpers/enumPropValidator'
import isTenantMixin from '@/components/mixins/isTenantMixin'
import debounce from 'lodash.debounce'
import Swal from 'sweetalert2'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import VueJsonToCsv from 'vue-json-to-csv'
import * as XLSX from 'xlsx'

import XLSXIcon from '@/assets/img/xlsx-icon.svg'
import XLSIcon from '@/assets/img/xls-icon.svg'

export default {
  model: {
    prop: 'data'
  },
  props: {
    data: { type: Array, default: Array },
    title: { required: true, type: String },
    isReadOnly: { default: false, type: Boolean },
    selectable: { type: Boolean, default: true },
    currentSort: { type: String },
    currentSortOrder: {
      type: String,
      default: 'asc',
      ...enumPropValidator('md-sort-order', ['asc', 'desc'])
    },
    customSort: { required: false, type: Function },
    customTotal: { required: true, type: Number },
    customHeader: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    rowClasses: { type: Function, default: () => ({}) },
    allowDeleteSelected: { type: Boolean, default: true },
    endpoint: { required: true },
    filter: { required: true },
    labels: { required: true },
    formatLabelFunction: { type: Function, required: true },
    createHeader: { type: Function },
    searchOptionsProps: { type: Array, default: Array },
    searchLabelsProps: { type: Array, default: Array },
    searchProps: { type: String, default: String }
  },
  components: {
    Pagination,
    VueJsonToCsv,
    XLSXIcon,
    XLSIcon
  },
  watch: {
    pagination: {
      handler: 'updatePagination',
      deep: true
    },
    loading (value) {
      if (value === false) {
        const vm = this
        setTimeout(() => {
          vm.delayedLoading = value
        }, 500)
      } else {
        this.delayedLoading = value
      }
    }
  },
  mixins: [isTenantMixin],
  computed: {
    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total () {
      return this.customTotal ?? (this.data?.length || 0)
    },
    progress () {
      return this.toFixed(this.progressGeneration, 1) * 100
    },
    formatedCVSLabels () {
      let csvObjLabels = {}
      // ['Início', 'Duração', 'Fim']
      // { inicio: {title: 'Início'}, ...}
      this.labels.forEach((label) => {
        csvObjLabels[this.strToSlug(label)] = {
          title: label
        }
      })
      return csvObjLabels
    }
  },
  data () {
    return {
      searchOptions: this.searchOptionsProps,
      searchLabels: this.searchLabelsProps,
      search: this.searchProps,
      pagination: [],
      selected: [],
      delayedLoading: false,
      dialogsGeneration: false,
      loadingGeneration: {
        pdf: false,
        csv: false,
        print: false,
        xlsx: false,
        xls: false
      },
      progressGeneration: 0,
      csvData: [],
      csvName: null,
      fileType: 'pdf'
    }
  },
  methods: {
    updateSearch: debounce(function (value) {
      this.search = value
      this.$emit('search-query', value)
    }, 400),
    updateSearchOptions (nV) {
      this.$emit('search-options', nV)
    },
    updatePagination (pagination, oldPagination) {
      this.$emit('pagination', pagination, oldPagination)
    },
    clearSelection () {
      this.selected = []
      this.$emit('clear-selection')
    },
    resetPagination () {
      this.pagination = {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50]
      }
    },
    slowRequestMessage () {
      if (this.fileType === 'pdf') {
        return this.$t('dataTable.generatingPdf')
      } else if (this.fileType === 'xlsx') {
        return this.$t('dataTable.generatingXLSX')
      } else if (this.fileType === 'xls') {
        return this.$t('dataTable.generatingXLS')
      } else if (this.fileType === 'csv') {
        return this.$t('dataTable.generatingCSV')
      }
    },
    async generateFile (type) {
      this.fileType = type
      const totalItems = JSON.parse(JSON.stringify(this.customTotal))

      this.progressGeneration = 0
      if (totalItems > 1000) {
        this.dialogsGeneration = true
      }
      this.loadingGeneration[type] = true
      let filterClone = JSON.parse(JSON.stringify(this.filter))
      const perPage = 1000
      if (filterClone.perPage) {
        filterClone.perPage = perPage
      }
      let dataPages
      try {
        const response = await this.$axios.get(this.endpoint, {
          params: filterClone
        })
        dataPages = [...response.data.data]
        const totalPages = response.data.total / perPage
        this.progressGeneration = 0.1
        const unity = 0.9 / parseInt(totalPages)
        for (let i = 1; i < totalPages; i++) {
          if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('table.canceledByUser'))
          filterClone.page = i
          let subsequentResponse = await this.$axios.get(this.endpoint, {
            params: filterClone
          })
          dataPages = [...dataPages, ...subsequentResponse.data.data]
          this.progressGeneration += unity
        }

        if (type === 'pdf' || type === 'print') {
          let bodyLabels = []
          let labelLine = []
          dataPages.forEach(item => {
            if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('table.canceledByUser'))
            this.labels.forEach((element, index) => {
              labelLine.push(this.formatLabelFunction(item, index))
            })
            const messageColumn = labelLine[3].replace(/<[^>]*>?/gm, ' ')
            labelLine[3] = messageColumn.replace(/[^\p{L}\p{N}\p{P}\p{Z}^$\n]/gu, ' ')
            bodyLabels.push(labelLine)
            labelLine = []
          })
          // eslint-disable-next-line
          const doc = new jsPDF()

          let offSetY = this.createHeader(doc, this.customTotal)

          if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('table.canceledByUser'))
          doc.autoTable({
            startY: offSetY,
            headStyles: {
              overflow: 'linebreak',
              cellWidth: 'wrap'
            },
            pageBreak: 'auto',
            rowPageBreak: 'avoid',
            bodyStyles: { minCellWidth: 30 },
            head: [this.labels],
            body: bodyLabels
          })
          // checamos se queremos só o pdf ou também queremos imprimir
          if (type === 'pdf') {
            let timestamp = Date.now()
            doc.save(`${timestamp}_busca_por_mensagens.pdf`)
          } else if (type === 'print') {
            window.open(doc.output('bloburl'))
          }
        } else if (type === 'csv') {
          let bodyLabels = []
          let lineObject = {}
          dataPages.forEach(item => {
            if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('table.canceledByUser'))
            this.labels.forEach((element, index) => {
              lineObject[this.strToSlug(element)] = this.formatLabelFunction(item, index)
            })
            let tmp = document.createElement('DIV')
            tmp.innerHTML = lineObject['mensagem'] ? lineObject['mensagem'] : ''
            lineObject['mensagem'] = tmp.textContent || tmp.innerText || ''
            bodyLabels.push(lineObject)
            lineObject = {}
          })
          this.csvData = bodyLabels
          let timestamp = Date.now()
          this.csvName = `${timestamp}_busca_por_mensagens`
          this.$nextTick(() => {
            document.querySelector('#csv-component').click()
          })
        } else if (type === 'xlsx' || type === 'xls') {
          let bodyLabels = []
          let lineObject = {}
          dataPages.forEach(item => {
            if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('table.canceledByUser'))
            this.labels.forEach((element, index) => {
              lineObject[this.strToSlug(element)] = this.formatLabelFunction(item, index)
            })
            let tmp = document.createElement('DIV')
            tmp.innerHTML = lineObject['mensagem'] ? lineObject['mensagem'] : ''
            lineObject['mensagem'] = tmp.textContent || tmp.innerText || ''
            bodyLabels.push(lineObject)
            lineObject = {}
          })
          let timestamp = Date.now()
          let fileName = `${timestamp}_busca_por_mensagens`
          let wb = XLSX.utils.book_new()
          let ws = XLSX.utils.json_to_sheet(bodyLabels)
          XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
          if (type === 'xlsx') {
            XLSX.writeFile(wb, `${fileName}.xlsx`)
          } else if (type === 'xls') { XLSX.writeFile(wb, `${fileName}.xls`, { bookType: 'biff8' }) }
        }
      } catch (error) {
        if (error.message === this.$t('table.canceledByUser')) {
          Swal.fire({
            icon: 'error',
            title: this.$t('table.calledOff')
          })
        } else {
          if (type === 'csv') {
            Swal.fire({
              icon: 'error',
              title: this.$t('localDataTable.errorGeneratingCsv')
            })
          }
          if (type === 'xlsx') {
            Swal.fire({
              icon: 'error',
              title: this.$t('dataTable.errorGeneratingXlsx')
            })
          } else if (type === 'xls') {
            Swal.fire({
              icon: 'error',
              title: this.$t('dataTable.errorGeneratingXlsx')
            })
          } else {
            Swal.fire({
              icon: 'error',
              title: this.$t('dataTable.errorGeneratingPdf')
            })
          }
        }
      } finally {
        this.dialogsGeneration = false
        this.loadingGeneration[type] = false
        setTimeout(() => {
          this.progressGeneration = 0
        }, 100)
      }
    },
    toFixed (value, precision) {
      var power = Math.pow(10, precision || 0)
      return Math.round(value * power) / power
    },
    strToSlug (str) {
      str = str.replace(/^\s+|\s+$/g, '') // trim
      str = str.toLowerCase()

      // remove accents, swap ñ for n, etc
      var from = 'ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;'
      var to = 'aaaaaeeeeeiiiiooooouuuunc------'
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
      }

      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-') // collapse dashes

      return str
    }
  },
  created () {
    this.resetPagination()
  },
  mounted () {
    this.$nextTick(() => {
      const headers = this.$el.querySelectorAll('th .md-table-head-container .md-table-head-label')

      headers.forEach(el => {
        let title = el.textContent
        el.setAttribute('title', title)
      })
    })
  }
}
</script>

<style lang="css">
.invisible {
  visibility: hidden !important;
}
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
.md-checkbox.md-checked .md-checkbox-container:after {
  border-color: #33b231 !important;
  top: 1px !important;
  left: 6px !important;
}
.md-table-cell-container {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.md-table-alternate-header {
  top: 20px !important;
}
#chatList > .md-content > table > tbody > .md-table-row > .md-table-cell > .md-table-cell-container {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  display: block;
  -webkit-box-pack: none;
  -ms-flex-pack: none;
  justify-content: none;
}
#chatList > .md-content > table > thead > tr > .md-table-head > .md-table-head-container > .md-table-head-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  text-align: left;
}
#chatList > .md-content > table > thead > tr > .md-table-head:last-child > .md-table-head-container > .md-table-head-label {
  padding-right: 0px !important;
  /* text-align: right; */
}
#chatList > .md-content > table > tbody > .md-table-row > .md-table-cell:hover > .md-table-cell-container {
  text-overflow: clip;
  white-space: normal;
  word-break: break-all;
}

.md-tooltip {
  height: 22px !important;
  padding: 8px !important;
  position: absolute !important;
  z-index: 9999 !important;
  pointer-events: none !important;
  border-radius: 2px !important;
  border-top-left-radius: 2px !important;
  border-top-right-radius: 2px !important;
  border-bottom-right-radius: 2px !important;
  border-bottom-left-radius: 2px !important;
  transition: 0.15s cubic-bezier(0, 0, 0.2, 1) !important;
  transition-property: opacity, transform !important;
  will-change: opacity, transform, top, left !important;
  font-size: 10px !important;
  line-height: 22px !important;
  text-transform: none !important;
  white-space: nowrap !important;
  min-width: none !important;
  width: 170px !important;
  max-width: 1000px !important;
  height: auto !important;
  line-height: 20px !important;
  text-align: center !important;
  border-radius: 3px !important;
  background-color: rgba(97, 97, 97, 0.9) !important;
  color: white !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  white-space: normal !important;
  box-shadow: none !important;
}

.icon-size{
  width: 24px;
  height: 24px;
  margin:  4.5px 0;
}

.md-tooltip:after {
  opacity: 0;
}

#data-table #header .margin-top {
  margin-top: 15px;
}

#data-table #header .margin-left {
  margin-left: 8px;
}
</style>
